<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="650px" persistent>
      <v-card
        :loading="!!nowProcessingSupplierWithId || !fetched"
        :disabled="!!nowProcessingSupplierWithId || !fetched"
      >
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("common.supplier") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="showWindow = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form ref="supplierForm">
            <v-text-field
              outlined
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="tmpSupplier.name"
              v-model="tmpSupplier.name"
              :label="$t('common.legal_name')"
            ></v-text-field>
            <v-text-field
              outlined
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="tmpSupplier.inn"
              v-model="tmpSupplier.inn"
              :label="$t('common.inn')"
            ></v-text-field>
            <v-checkbox
              @change="
                tmpSupplier.is_enabled_search_by_pricelists =
                  !tmpSupplier.is_enabled_search_by_pricelists
              "
              :value="tmpSupplier.is_enabled_search_by_pricelists"
              :label="
                $t(
                  'viewSuppliers.search_by_pricelist_loaded_for_this_supplier_is_enabled'
                )
              "
            ></v-checkbox>
            <v-checkbox
              v-if="isApiSuppliersConfigVisible"
              @change="changeAvailableBySupplierApi"
              :value="tmpSupplier.is_available_by_suppliers_api"
              :label="$t('viewSuppliers.is_available_by_suppliers_api')"
            ></v-checkbox>
            <div v-if="tmpSupplier.is_available_by_suppliers_api && isApiSuppliersConfigVisible">
              <v-select
                :label="$t('viewSuppliers.suppliers_available_by_api')"
                :items="
                  suppliersFromAPI.filter(
                    (item) =>
                      (item && item.platform_supplier_id === null) ||
                      (item && item.platform_supplier_id === supplierId)
                  )
                "
                v-model="tmpSupplier.suppliers_api_code"
                class="pointer no-print"
                item-text="type"
                item-value="supplier"
                outlined
              >
                <template v-slot:selection="{ item }">
                  <img :src="item.logo" class="ma-1 ml-0" />{{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  <img :src="item.logo" class="ma-1 ml-0" />{{ item.name }}
                </template>
              </v-select>

              <v-card elevation="1" v-if="selectedApiSupplier">
                <v-toolbar elevation="0">
                  <template v-if="selectedApiSupplier.config.active === true">
                    <v-icon color="success" text-color="success" left
                      >fa-check-circle</v-icon
                    >
                  </template>
                  <template v-else>
                    <v-icon color="red" text-color="red" left
                      >fa-times-circle</v-icon
                    >
                  </template>

                  <v-toolbar-title
                    ><span
                      >{{ $t("viewSuppliers.API_supplier_config") }}:
                      {{ selectedApiSupplier.name }}</span
                    ></v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <img
                    :src="selectedApiSupplier.logo + '?7'"
                    style="max-width: 150px; max-height: 30px"
                  />
                </v-toolbar>
                <div :loading="selectedApiSupplier.nowSave">
                  <v-divider></v-divider>
                  <v-form
                    lazy-validation
                    class="pa-2"
                    v-if="!selectedApiSupplier.nowSave"
                    :ref="'form' + selectedApiSupplier.supplier"
                  >
                    <span class="grey--text caption">{{ $t("Site") }}</span
                    ><br />
                    <a
                      :href="selectedApiSupplier.websait"
                      target="_blank"
                      class="mb-3 d-block"
                    >
                      {{ selectedApiSupplier.websait }}
                    </a>
                    <template
                      v-for="(value, cfgname) in selectedApiSupplier.config"
                    >
                      <template v-if="cfgname == 'auth_params'">
                        <template
                          v-for="(value, name) in selectedApiSupplier.config[
                            cfgname
                          ]"
                        >
                          <v-text-field
                            :label="$t('viewSuppliersSettings.' + name)"
                            :rules="[
                              (v) => {
                                if (v === 0) {
                                  return true;
                                } else {
                                  return (
                                    !!v ||
                                    $t(
                                      'form.validationErrors.field_is_required'
                                    )
                                  );
                                }
                              },
                            ]"
                            required
                            v-model="selectedApiSupplier.config[cfgname][name]"
                          ></v-text-field>
                        </template>
                      </template>
                      <template
                        v-if="
                          cfgname != 'active' &&
                          cfgname != 'allowed_queries' &&
                          cfgname != 'auth_params' &&
                          cfgname != 'url' &&
                          cfgname != 'margin' &&
                          cfgname != 'specific'
                        "
                      >
                        <v-text-field
                          :label="$t('viewSuppliersSettings.' + cfgname)"
                          :rules="[
                            (v) => {
                              if (v === 0) {
                                return true;
                              } else {
                                return (
                                  !!v ||
                                  $t('form.validationErrors.field_is_required')
                                );
                              }
                            },
                          ]"
                          required
                          v-model="selectedApiSupplier.config[cfgname]"
                        ></v-text-field>
                      </template>
                      <template v-if="cfgname === 'specific'">
                        <template v-for="field in Object.keys(selectedApiSupplier.config.specific)">
                          <v-text-field

                              :label="field"
                              required
                              v-model="selectedApiSupplier.config.specific[field]"
                          ></v-text-field>
                        </template>
                      </template>
                      <template v-if="cfgname === 'active'">
                        <v-switch
                          v-model="selectedApiSupplier.config.active"
                          :label="
                            selectedApiSupplier.config.active
                              ? $t('viewSuppliers.is_enabled_search_by_API')
                              : $t('viewSuppliers.is_disabled_search_by_API')
                          "
                        ></v-switch>
                      </template>

                      <template v-if="cfgname === 'allowed_queries'">
                        <v-text-field
                          :label="
                            $t(
                              'viewSuppliersSettings.allowed_queries_counter_max'
                            )
                          "
                          required
                          v-model="
                            selectedApiSupplier.config.allowed_queries[
                              'counter_max'
                            ]
                          "
                        ></v-text-field>
                        <v-text-field
                          :label="$t('viewSuppliersSettings.exp_time_min')"
                          required
                          v-model="
                            selectedApiSupplier.config.allowed_queries[
                              'exp_time(min)'
                            ]
                          "
                        ></v-text-field>
                      </template>
                    </template>
                  </v-form>
                  <v-card-actions>
                    <v-row justify="end" class="pr-3">
                      <v-btn
                        text
                        :disabled="selectedApiSupplier.nowSave"
                        :loading="selectedApiSupplier.nowSave"
                        @click="checkSupplierAPIConfig(selectedApiSupplier)"
                      >
                        {{ selectedApiSupplier.nowSave ? '' : $t("viewSuppliersSettings.check_config") }}
                      </v-btn>
                    </v-row>
                  </v-card-actions>
                </div>
              </v-card>
            </div>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions class="pa-0 mx-0">
              <v-spacer></v-spacer>
              <v-btn
                :loading="!!nowProcessingSupplierWithId || !fetched"
                :disabled="!!nowProcessingSupplierWithId || !fetched"
                class="mt-5"
                color="primary"
                @click="submit"
                @keyup.enter="submit"
                elevation="0"
              >
                {{ $t("common.save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import CalendarMixin from "@/mixins/calendar";

export default {
  name: "SupplierWindow",
  mixins: [CommonMixin, CalendarMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    supplierId: {
      type: Number,
      default: null,
    },
    customer: null,
  },
  data: () => ({
    tmpSupplier: {
      name: null,
      is_enabled_search_by_pricelists: false,
      inn: null,
      is_available_by_suppliers_api: false,
    },
    connectedApiSupplierName: false, //имя используется для отключения поставщика по API при его откреплении
  }),
  methods: {
    changeAvailableBySupplierApi() {
      this.tmpSupplier.is_available_by_suppliers_api =
        !this.tmpSupplier.is_available_by_suppliers_api;
      if (!this.tmpSupplier.is_available_by_suppliers_api) {
        this.tmpSupplier.suppliers_api_code = null;
      }
    },
    async saveSupplierConfig(data, needValidate=true) {
      if(needValidate){
        if(!this.$refs[`form${data.supplier}`].validate()){
          return false;
        }
      }
      this.nowSave = data.supplier;
      return await this.$store.dispatch("suppliers/saveSupplierAPIConfig", {
        supplier: data.supplier,
      });
    },
    checkSupplierAPIConfig: function (data) {
      if (this.$refs[`form${data.supplier}`].validate()) {
        this.nowSave = data.supplier;
        this.$store.dispatch("suppliers/checkSupplierAPIConfig", {
          supplier: data.supplier,
        });
      }
    },
    async submit() {
      if (!this.$refs.supplierForm.validate()) return;
      let isSavedSupplierByApi = false;
      if(this.selectedApiSupplier) {
        if (Array.isArray(this.selectedApiSupplier.config.specific) || !this.selectedApiSupplier.config.specific) {
          this.selectedApiSupplier.config.specific = {}
        }
      }
      if (
        this.selectedApiSupplier &&
        this.tmpSupplier.is_available_by_suppliers_api
      ) {
        isSavedSupplierByApi = await this.saveSupplierConfig(
          this.selectedApiSupplier
        );
      } else {
        if (this.connectedApiSupplierName) {
          //отключим в API Suppliers
          let supplierForDisableByApi = this.suppliersFromAPI.find(
            (item) => item.supplier === this.connectedApiSupplierName
          );
          if (supplierForDisableByApi) {
            supplierForDisableByApi.config.active = false;
            isSavedSupplierByApi = await this.saveSupplierConfig(
                supplierForDisableByApi, false
            );
          }
        } else {
          isSavedSupplierByApi = true;
        }
      }
      if (isSavedSupplierByApi) {
        if (!this.supplierId) {
          this.$store
            .dispatch("suppliers/store", this.tmpSupplier)
            .then((createdSupplier) => {
              if (createdSupplier.id > 0) {
                this.$emit("store", createdSupplier);
                this.$emit("hide");
              }
            });
        } else {
          this.$store
            .dispatch("suppliers/update", this.tmpSupplier)
            .then((supplier) => {
              if (supplier.id > 0) {
                this.$emit("update", supplier);
                this.$emit("hide");
              }
            });
        }
      }
    },
  },
  computed: {
    /**
     * это свойство отвечает за сокрытие настроек API поставщиков для не русскоязычных пользователей
     */
    isApiSuppliersConfigVisible(){
      return this.lang === 'ru';
    },
    selectedApiSupplier() {
      return this.suppliersFromAPI.find(
        (item) => item.supplier === this.tmpSupplier.suppliers_api_code
      );
    },
    ...mapFields("suppliers", [
      "savingInProgress",
      "nowProcessingSupplierWithId",
      "supplier",
      "fetched",
      "suppliersFromAPI",
    ]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$refs["supplierForm"].resetValidation();
        this.$emit("hide");
      },
    },
  },
  mounted() {},

  watch: {
    show(to) {
      if(this.isApiSuppliersConfigVisible) {
        this.$store.dispatch("suppliers/getSuppliersByAPIWithConfig");
      }
      if (to) {
        if (!this.supplierId) {
          this.tmpSupplier.name = null;
          this.tmpSupplier.is_enabled_search_by_pricelists = null;
          this.tmpSupplier.inn = null;
          if (this.customer) {
            this.tmpSupplier.customer_id = this.customer.id;
          }
        } else {
          //получение
          this.$store
            .dispatch("suppliers/getSupplier", this.supplierId)
            .then(() => {
              this.tmpSupplier = this.supplier;
              this.connectedApiSupplierName = this.supplier.suppliers_api_code;
            });
        }
      }
    },
  },
};
</script>
